<template>
  <div class="text-block-header">
    <div class="container">
      <text-block
        v-if="heading"
        :content="`<${headingTag}>${heading}</${headingTag}>`"
        :tag="headingTag"
      />
      <text-block
        v-if="content"
        :content="content"
        :collapsable="!noCollapse"
        tag="p"
      />

      <div class="px-2">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import TextBlock from "@/components/TextBlock"

export default {
  props: {
    heading: { type: String, default: "" },
    content: { type: String, default: "" },
    noCollapse: { type: Boolean, default: false },
    large: { type: Boolean, default: false }
  },

  components: {
    TextBlock
  },

  computed: {
    headingTag() {
      return this.large ? "h1" : "h2"
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables";

.text-block-header {
  background: $color-ui--white;
  position: relative;
  padding-top: $size--2;
  padding-bottom: $size--2;
}
</style>
